import axios from '@/axios'

const activity = {
  async queryFirstChargeActivityDetail(params) {
    return await axios.post('/uc/firstChargeActivity/queryFirstChargeActivityDetail', params , { des: '直客pc判断是否允许访问活动', sTime: new Date().getTime() }) 
  },
  async applyGold(params) {//用户中心——首充活动——立即申领交易赠金
    return await axios.post('/uc/firstChargeActivity/applyGold', params , { des: '直客pc立即申领交易赠金', sTime: new Date().getTime() }) 
  }
}
export default activity


// WEBPACK FOOTER //
// ./src/api/activity.js